import { ICONS as ICONS_ENUM } from 'Components/utils/icon/icons';

const MEDIA_TYPES = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  VIDEOS360: 'videos360',
  SOCIALPICTURES: 'socialPictures',
};

const ORDERED_MEDIAS = [
  MEDIA_TYPES.PHOTOS,
  MEDIA_TYPES.VIDEOS,
  MEDIA_TYPES.VIDEOS360,
  MEDIA_TYPES.SOCIALPICTURES,
];

const ORDERED_MEDIAS_THUMBNAILS = [
  MEDIA_TYPES.VIDEOS360,
  MEDIA_TYPES.VIDEOS,
  MEDIA_TYPES.PHOTOS,
  MEDIA_TYPES.SOCIALPICTURES,
];

const ICONS = {
  [MEDIA_TYPES.PHOTOS]: ICONS_ENUM.PHOTO_ALBUM,
  [MEDIA_TYPES.VIDEOS]: ICONS_ENUM.VIDEOS,
  [MEDIA_TYPES.VIDEOS360]: ICONS_ENUM.VIDEOS_360,
  [MEDIA_TYPES.SOCIALPICTURES]: ICONS_ENUM.INSTAGRAM,
};

export { ICONS, MEDIA_TYPES, ORDERED_MEDIAS, ORDERED_MEDIAS_THUMBNAILS };
